import React, { useEffect, useState } from 'react';
import scrollIcon from '../../../img/scroll/scroll.svg'
import './scrollButton.css';

const ScrollButton = ({ scrollXL }) => {
    const [showScroll, setShowScroll] = useState(false);

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 250) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 250) {
            setShowScroll(false)
        }
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop)
        return function cleanup() {
            window.removeEventListener('scroll', checkScrollTop)
        }
    })




    return (
        <button className={`${scrollXL === false ? "scrollTop scrollTopXL rounded-circle" : "scrollTop rounded-circle"}`}  onClick={scrollTop} style={{ display: showScroll ? 'flex' : 'none' }}>
            <img src={scrollIcon} alt="icono-scroll"/>
        </button>
    );
}

export default ScrollButton;